import { Row, TrackerStat } from "@/components";

import { PlacementStatus, PlacementTrackerResponse } from "@/types";

export const PlacementTrackerStats = ({
  placements,
}: {
  placements: PlacementTrackerResponse[];
}) => {
  const revenueEarned = placements
    .filter((p) =>
      [PlacementStatus.EMPLOYED, PlacementStatus.COMPLETED].includes(p.status),
    )
    .reduce((sum, p) => sum + (p.revenueEarned ?? 0), 0);

  const pendingRevenueEarned = placements
    .filter((p) =>
      [PlacementStatus.OFFERED, PlacementStatus.ACCEPTED].includes(p.status),
    )
    .reduce((sum, p) => sum + (p.revenueEarned ?? 0), 0);

  const totalPlacements = placements.length;

  const totalJobs = new Set(placements.map((p) => p.job.id)).size;

  const totalCompanies = new Set(placements.map((p) => p.company.id)).size;

  return (
    <Row className="gap-2">
      <TrackerStat
        label="Revenue Earned"
        value={`$${revenueEarned.toLocaleString(undefined, { maximumFractionDigits: 2 })}`}
      />
      <TrackerStat
        label="Pending Revenue Earned"
        value={`$${pendingRevenueEarned.toLocaleString(undefined, { maximumFractionDigits: 2 })}`}
      />
      <TrackerStat label="Total Placements" value={totalPlacements} />
      <TrackerStat label="Total Jobs" value={totalJobs} />
      <TrackerStat label="Total Companies" value={totalCompanies} />
    </Row>
  );
};
